import script from "./AlarmBreathingLight.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmBreathingLight.vue?vue&type=script&setup=true&lang=js"

import "./AlarmBreathingLight.vue?vue&type=style&index=0&id=24c1ce29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c1ce29"]])

export default __exports__